<template>
  <div
    class="custom-icon"
    :style="{
      maskImage: `url(${icon})`,
      width: size,
      height: size,
    }"></div>
</template>

<script setup>
  const props = defineProps({
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: '20px',
    },
    sizeMobile: {
      type: String,
      default: '16px',
    },
  });
</script>

<style scoped lang="scss">
  .custom-icon {
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    background-color: currentColor;

    @media screen and (max-width: 768px) {
      width: v-bind('props.sizeMobile') !important;
      height: v-bind('props.sizeMobile') !important;
    }
  }
</style>
